<template>
    <div class="container" style="float: none;">
        <loader v-if="mediaLoading"/>
        <div>
            <div v-for="mediaType in docMediaTypes" class="form-group" :key="mediaType.name">
                <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
                <div class="col-md-10">
                    <table v-show="mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId})" class="table">
                        <thead>
                            <tr v-if="mediaType.name === 'Shape Files'">
                                <th>Download</th>
                                <th>File Name</th>
                                <th>Status</th>
                                <th>Layers Processed</th>
                                <th>Layer Count</th>
                                <th>Processing Complete Date</th>
                                <th>Comment</th>
                                <th>Uploaded By</th>
                                <th v-if="!formDisabled">Delete</th>
                            </tr>
                            <tr v-else>
                                <th style="width:10%">Download</th>
                                <th style="width:15%" v-if="mediaType.name === 'Images'">Image Type</th>
                                <th style="width:25%">File Name</th>
                                <th style="width:25%">Comment</th>
                                <th style="width:15%">Uploaded By</th>
                                <th style="width:10%" v-if="!formDisabled">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="mediaItem in mediaList.filter(m => {return m.mediaTypeId === mediaType.mediaTypeId && !!m.mediaId})" :key="mediaItem.mediaId">
                                <td>
                                    <div style="text-align: center;">
                                        <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)"></a>
                                    </div>
                                </td>
                                <td>{{mediaItem.filename}}</td>
                                <td v-if="mediaType.name === 'Images'">{{ imageSubtypes.find(x => { return x.mediaSubtypeId === mediaItem.mediaSubtypeId }).name }}</td>
                                <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileCurrentLayerGisJobStatus}}</td>
                                <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileCurrentLayerIndex}}</td>
                                <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileLayerCount}}</td>
                                <td v-if="mediaType.name === 'Shape Files'">{{mediaItem.shapeFileProcessingCompleteDate ? mediaItem.shapeFileProcessingCompleteDate.format('MM/DD/YYYY, hh:mm A') : ''}}</td>
                                <td>{{mediaItem.comment}}</td>
                                <td>{{mediaItem.createdBy}}</td>
                                <td v-if="!formDisabled">
                                    <div style="text-align: center;">
                                        <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(mediaItem.mediaId)"></a>
                                    </div>
                                </td>
                            </tr>
                            <tr v-for="mediaItem in mediaList.filter(m => {return m.mediaTypeId === mediaType.mediaTypeId && !!m.scantoolMediaId})" :key="mediaItem.scantoolMediaId">
                                <td>
                                    <div style="text-align: center;">
                                        <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="scanMediaDownloadRow(mediaItem.scantoolMediaId, mediaItem.filename)"></a>
                                    </div>
                                </td>
                                <td>{{mediaItem.filename}}</td>
                                <td>{{mediaItem.comment}}</td>
                                <td v-if="!formDisabled && isAdmin">
                                    <div style="text-align: center;">
                                        <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="scanMediaRemove(mediaItem.scantoolMediaId)"></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="!(mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId}))">
                        <label>No matching records</label>
                    </div>
                </div>
            </div>

            <div class="form-group" v-if="docMediaTypesFiltered.length > 0">
                <label class="col-md-2">Add File</label>
                <div class="col-md-10">
                    <fieldset>
                        <form @submit.prevent class="form" id="mediaForm" data-vv-scope="mediaFile">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaType') }">
                                        <label>Type</label>
                                        <select name="mediaType" class="form-control" v-model="mediaTypeId" v-validate="'required'" data-vv-validate-on="none">
                                            <option disabled :value='null'>Select a value</option>
                                            <option v-for="mediaType in docMediaTypesFiltered" v-bind:value="mediaType.mediaTypeId" :key="mediaType.mediaTypeId">
                                                {{mediaType.name}}
                                            </option>
                                        </select>
                                        <div><span v-show="errors.has('mediaFile.mediaType')" class="has-error">File type is required</span></div>
                                    </div>
                                </div>
                                <div v-if="mediaTypeId === 15" class="col-md-2">
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaSubtype') }">
                                        <label>Subtype</label>
                                        <select name="mediaSubtype" class="form-control" v-model="mediaSubtypeId" v-validate="'required'" data-vv-validate-on="none">
                                            <option disabled :value='null'>Select a value</option>
                                            <option v-for="subtypes in imageSubtypes" v-bind:value="subtypes.mediaSubtypeId" :key="subtypes.mediaSubtypeId">
                                                {{subtypes.name}}
                                            </option>
                                        </select>
                                        <div><span v-show="errors.has('mediaFile.mediaSubtype')" class="has-error">Subtype is required</span></div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                        <label>File</label><br>
                                        <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'" data-vv-validate-on="none">
                                        <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Comment</label>
                                        <input type="text" class="form-control" v-model="comment">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3"></div>
                                <div class="col-md-8">
                                    <div v-show="errors.any('mediaFile')">
                                        <span class="has-error">Validation issues must be corrected prior to upload</span>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary col-md-2" v-on:click="addFile">Upload</button>
                        </form>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mediaService from '../services/mediaService'
import scantoolMediaService from '../services/scantoolMediaService'
import loggingService from '../services/util/loggingService'
import loader from '../components/Loader.vue'

export default {
    name: 'investigationDocuments',
    components: {
        loader
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            docMediaTypes: [
                {name: 'Shape Files', mediaTypeId: mediaService.mediaType.InvestigationShapeFiles},
                {name: 'Reports', mediaTypeId: mediaService.mediaType.InvestigationReports},
                {name: 'Supporting Documents', mediaTypeId: mediaService.mediaType.InvestigationSupportingDocuments},
                {name: 'Correspondence', mediaTypeId: mediaService.mediaType.InvestigationCorrespondence},
                {name: 'Images', mediaTypeId: mediaService.mediaType.InvestigationImages}
            ],
            imageSubtypes: [
                {name: 'Other', mediaSubtypeId: mediaService.mediaSubtype.InvestigationOtherImage}
            ],
            mediaList: [],
            comment: '',
            mediaTypeId: null,
            mediaSubtypeId: null,
            filename: '',
            mediaRefreshIntervalId: null,
            mediaRefreshCount: 0
        }
    },
    props: {
        parentId: {},
        formDisabled: { default: false },
        documentPermissions: { default: ['All'] },
        loadOnMount: { default: true },
        isAdmin: { default: false }
    },
    computed: {
        continueMediaRefreshCheck: function () {
            return this.mediaList && this.mediaList.length > 0 && this.mediaRefreshCount < 100 && this.mediaList.some(x => {
                return !x.shapeFileProcessingCompleteDate && x.isShapeFile
            })
        },
        stopMediaRefreshCheck: function () {
            return this.mediaList && this.mediaList.length > 0 && !this.mediaList.some(x => {
                return !x.shapeFileProcessingCompleteDate && x.isShapeFile
            })
        },
        docMediaTypesFiltered: function () {
            return this.docMediaTypes.filter(m => this.canUpload(m.name))
        }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadImages () {
            var promises = []
            this.imageSubtypes.forEach(imageSubtype => {
                promises.push(this.loadMedia(mediaService.mediaType.InvestigationImages, imageSubtype.mediaSubtypeId, this.parentId))
            })
            return Promise.all(promises).then(result => { return result })
        },
        loadScanToolMedia (mediaTypeId) {
            return scantoolMediaService.listByMediaTypeId(this.$http, this.parentId, mediaTypeId).then(result => {
                if (result.data && result.data.length > 0) {
                    result.data.forEach(r => { r.comment = 'scanned document' })
                    this.mediaList = this.mediaList.concat(result.data)
                }
                return result
            })
        },
        loadData () {
            this.mediaLoading = true
            var promises = [this.loadImages()]
            this.mediaList = []
            this.docMediaTypes.forEach(mediaType => {
                promises.push(this.loadMedia(mediaType.mediaTypeId, null, this.parentId))
                promises.push(this.loadScanToolMedia(mediaType.mediaTypeId))
            })
            Promise.all(promises).then(result2 => {
                this.log('After load, media list count: ' + this.mediaList.length)
                this.mediaLoading = false
                this.mediaRefresh()
            })
        },
        canUpload (mediaName) {
            if (this.documentPermissions.includes('All')) {
                return true
            } else if (this.documentPermissions.includes('None')) {
                return false
            } else {
                return this.documentPermissions.includes(mediaName)
            }
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                this.log(`Validiting and Submitting File.`)
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                    mediaService.putFile(this.$http, this.mediaTypeId, this.mediaSubtypeId, this.parentId, file, this.comment).then(result => {
                        //clean form
                        this.loadData()
                        this.clearFileInput()
                        this.errors.clear()
                    })
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        clearFileInput () {
            document.forms['mediaForm'].reset()
            this.mediaTypeId = null
            this.mediaSubtypeId = null
            this.comment = ''
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        },
        mediaRemove (mediaId) {
            if (confirm('Are you sure you want to remove this file/document?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadData()
                })
            }
        },
        refreshShapeFileMedia () {
            this.log('refreshing shape files:')
            this.mediaList = this.mediaList.filter(x => x.mediaTypeId !== mediaService.mediaType.InvestigationShapeFiles)
            return this.loadMedia(mediaService.mediaType.InvestigationShapeFiles, null, this.parentId)
        },
        mediaRefresh () {
            this.mediaRefreshCount = 0
            if (this.mediaRefreshIntervalId) clearInterval(this.mediaRefreshIntervalId)
            this.$emit('mediaRefreshStarted')
            if (this.stopMediaRefreshCheck) {
                this.$emit('mediaRefreshComplete')
                return
            }
            this.mediaRefreshIntervalId = setInterval(() => {
                if (this.continueMediaRefreshCheck) {
                    this.log('media refresh count:' + this.mediaRefreshCount)
                    this.mediaRefreshCount++
                    this.refreshShapeFileMedia().then(response => {
                        if (this.stopMediaRefreshCheck) {
                            clearInterval(this.mediaRefreshIntervalId)
                            this.$emit('mediaRefreshComplete')
                        }
                    })
                } else {
                    clearInterval(this.mediaRefreshIntervalId)
                    this.$emit('mediaRefreshComplete')
                }
            }, 5000)
        },
        scanMediaDownloadRow (scantoolMediaId, filename) {
            loggingService.log(this.isDebug, this.componentName, 'mediaDownloadRow - scantoolMediaId: ' + scantoolMediaId)

            scantoolMediaService.get(this.$http, scantoolMediaId).then(response => {
                mediaService.saveFileToDownload(response, filename)
            })
        },
        scanMediaRemove (scantoolMediaId) {
            if (confirm('Are you sure you want to remove this file/document?')) {
                scantoolMediaService.removeByScantoolMediaId(this.$http, scantoolMediaId).then(result => {
                    this.loadData()
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// InvestigationDocuments.vue?2a465b90